<template>
    <div class="d-flex justify-content-center align-items-center mt-4">
        <div class="d-flex flex-column agro-settings-card p-4 col-3">
            <ProgressSpinner v-if="loading" class="progress-spinner"/>
            <div v-else>
                <div class="d-flex flex-column kt-font-lg my-3 px-4">
                    <div class="d-flex flex-column mb-4">
                        <div class="d-flex justify-content-center align-items-center mb-4">
                            <div>
                                {{ $t('AppAgroSettingsCard.Período de agrupamento de operações') }}
                            </div>
                            <i class="pi pi-question-circle pl-2" v-tooltip.bottom="getGroupingText()"/>
                        </div>
                        <div class="d-flex justify-content-between align-items-center my-2"
                             v-for="operation in operationsGrouping">
                            <div>
                                {{ operation.label }}
                            </div>
                            <InputNumber v-model="operation.days" :placeholder="$t('AppAgroSettingsCard.15 dias')"
                                         class="input-width" :suffix="$t('AppAgroSettingsCard. dias')" :min="1" :max="365"/>
                        </div>
                        <hr class="card-divider mt-4"/>
                        <div class="d-flex align-items-center mt-3">
                            <Checkbox id="field_detection" v-model="fieldDetection" :binary="true"/>
                            <label for="field_detection" class="ml-2 mb-0">
                                {{ $t('AppAgroSettingsCard.Gerar operação ao entrar em talhão') }}
                            </label>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-end">
                    <Button :label="$t('AppAgroSettingsCard.Salvar')" @click="updateAgroPreferences"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Tooltip from 'primevue/tooltip';
import Checkbox from 'primevue/checkbox';
import InputNumber from 'primevue/inputnumber';
import Button from 'primevue/button';
import ProgressSpinner from "primevue/progressspinner";

import {OPERATIONS_LIST} from "@/components/views/agriculture/AppAgricultureOptions";

export default {
    mounted() {
        this.handleAgroPreferences();
    },
    data() {
        return {
            parsingData: false,
            operationsGrouping: [
                {
                    name: 'SEEDING',
                    days: 15
                },
                {
                    name: 'HARVEST',
                    days: 15
                },
                {
                    name: 'MOWING',
                    days: 15
                },
                {
                    name: 'TILLAGE',
                    days: 15
                },
                {
                    name: 'DRY_APPLICATION',
                    days: 15
                },
                {
                    name: 'LIQUID_APPLICATION',
                    days: 15
                }
            ],
            fieldDetection: false
        }
    },
    props: {
        agroPreferences: {
            type: Object
        },
        gettingData: {
            type: Boolean
        }
    },
    methods: {
        handleAgroPreferences() {
            this.parsingData = true;
            if (this.agroPreferences) {
                let operations = this.agroPreferences.operations_grouping.map(group => ({name: group.name, days: group.days ? group.days : 15}))
                this.operationsGrouping = JSON.parse(JSON.stringify(operations));
                this.fieldDetection = this.agroPreferences.field_detection;
            }

            this.parseGrouping();
        },
        parseGrouping() {
            this.operationsGrouping.forEach((operation) => {
                operation.label = this.findLabelByName(operation.name);
                operation.days ??= null;
            })

            this.parsingData = false;
        },
        findLabelByName(name) {
            let foundOp = OPERATIONS_LIST().find(op => op.name === name);
            return foundOp.label;
        },
        updateAgroPreferences() {
            if(!this.newData){
                this.$toast.add({
                    severity: 'warn',
                    summary: this.$t('AppOrganizationSettings.O formulário não possui alterações!'),
                    life: 5000
                });
                return
            }

            let setPreferences = {
                field_detection: this.fieldDetection,
                operations_grouping: this.operationsGrouping.map(group => ({
                    operation_type: group.name,
                    days: group.days
                }))
            }
            this.$emit('save', setPreferences);
        },
        restoreData() {
            this.operationsGrouping.map(group => group.days = null);
            this.fieldDetection = false;
        },
        getGroupingText() {
            return this.$t('AppAgroSettingsCard.O período deve ser um valor entre 1 e 365 dias');
        }
    },
    computed: {
        newData: function () {
            if (!this.agroPreferences || this.fieldDetection !== this.agroPreferences.field_detection) {
                return true;
            }

            let daysChanged = false;
            this.operationsGrouping.forEach(group => {
                let foundGroup = this.agroPreferences.operations_grouping.find(g => g.name === group.name);
                if (foundGroup.days && foundGroup.days !== group.days) {
                    daysChanged = true;
                }
            })

            return daysChanged;
        },
        loading: function () {
            return this.gettingData || this.parsingData;
        }
    },
    watch: {
        agroPreferences: function () {
            this.handleAgroPreferences();
        }
    },
    directives: {
        'tooltip': Tooltip
    },
    components: {
        Button, InputNumber, Checkbox, ProgressSpinner, Tooltip
    }
}
</script>

<style scoped>
.agro-settings-card {
    background: white;
    border-radius: 1rem;
}

.input-width {
    width: 200px;
}

.card-divider {
    border-bottom: lightgrey 1px dashed;
    width: 80%;
}
</style>
